import api from "../api";

export const useUserCancelWithdrawReuqest = (id) =>
  api.put(`/withdraw/${id}`).then((res) => res.data);
